import React from "react";
import { LandingPageRow } from "../LandingPageSection";
import styled from "@emotion/styled";
import { CustomThemeType } from "../../../../context/Providers";
import CallToActionButton from "../../../../components/CallToActionButton/CallToActionButton";
import SectionFooter from "../SectionFooter";
import { scrollToSection } from "../../../../util/util";
import { useWindowSize } from "react-use";

interface Section1ContentProps {

}

const Col1 = styled.div<{ theme?: CustomThemeType }>`
    width: 35%;
    height: 50vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 0 60px;
    z-index: 10;
    h1 {
        color: ${p => p.theme.foreground};
        padding: 0;
        margin: 0;
        font-weight: 500;
        font-size: 4rem;
    }
    h4 {
        color: color-mix(in srgb, ${p => p.theme.foreground}, ${p => p.theme.background} 50%);
        /* color: color-mix(in hsl, black, white 60%); */
        /* color: ${p => p.theme.foreground}; */
        /* color: ${p => p.theme.background}; */
        margin-bottom: 4.5rem;
        margin-top: 3rem;
        font-size: 2rem;
    }
    @media (max-width: 1425px) {
        h1 {
            font-size: 3rem;
        }
        h4 {
            font-size: 1.75rem;
        }
    }
    @media (max-width: 1200px) {
        width: 50%;
        align-items: center;
        height: auto;
        margin: 4rem 3rem;
        h1 {
            text-align: center;
        }
        h4 {
            text-align: center;
        }
    }
    @media (max-width: 1000px) {
        width: 80%;
    }
    @media (max-width: 450px) {
        width: 100%;
        h1 {
            font-size: 2rem;
        }
        h4 {
            font-size: 1.2rem;
        }
    }
`;

const Col2 = styled.div<any>`
    width: 30%;
    height: 50vh;
    position: relative;
    margin: 0 60px;
    img {
        width: 100%;
        border-radius: 1rem;
    }
    & > div:first-of-type {
        width: 80%;
        position: absolute;
        bottom: 0;
        right: 0;
    }
    /* & > div:first-of-type {
        width: 50%;
        position: absolute;
        bottom: 0;
        left: 0;
    } */
    /* & > div:last-of-type {
        width: 50%;
        position: absolute;
        top: 0;
        right: 0;
    } */
        & img {
            box-shadow: 0px 0px 10px #aaaaaa;
        }
    @media (max-width: 1200px) {
        display: none;
        height: auto;
    }
`;

const Section1Content: React.FC<Section1ContentProps> = () => {
    const { width } = useWindowSize();
    return (
        <>
            <LandingPageRow height={width > 1200 ? "70vh" : "auto"}>
                <Col1>
                    <h1>
                        Stop Letting Paperwork<br />
                        Sabotage Your Deliveries
                    </h1>
                    <h4>
                        Digitizing pick lists simplifies the delivery process for dealers and manufacturers.
                    </h4>
                    <CallToActionButton onClick={(e) => scrollToSection(1, e.nativeEvent.target)}>Learn More</CallToActionButton>
                </Col1>
                <Col2>
                    <div>
                        <img src="./assets/ai-img-1.png" />
                    </div>
                </Col2>
            </LandingPageRow>
            <SectionFooter sectionIndex={0}/>
        </>
    );
}

export default Section1Content;
